export const ContextualTargetingType = {
    targets: {
        label: 'Targets',
        key: 'targets'
    },
    targetsSets: {
        label: 'Targets Sets (Concepts)',
        key: 'targetsSets'
    }
}